import { render, staticRenderFns } from "./ItemCardBasicData.vue?vue&type=template&id=8f3fd3ac&scoped=true"
import script from "./ItemCardBasicData.vue?vue&type=script&lang=ts"
export * from "./ItemCardBasicData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3fd3ac",
  null
  
)

export default component.exports